/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshserviceIncidentConfigurationMappingBase {
    getFixupPrototypeFunction() { return FreshserviceIncidentConfigurationMappingBase.fixupPrototype; }

    static newInstance(model: Partial<FreshserviceIncidentConfigurationMappingBase>): FreshserviceIncidentConfigurationMappingBase {
        let obj = Object.assign(new FreshserviceIncidentConfigurationMappingBase(), model);
        FreshserviceIncidentConfigurationMappingBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshserviceIncidentConfigurationMappingBase>): FreshserviceIncidentConfigurationMappingBase {
        if (!model) return null;
        return FreshserviceIncidentConfigurationMappingBase.newInstance(<FreshserviceIncidentConfigurationMappingBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshserviceIncidentConfigurationMappingBase) {
        if (!obj) return;

        models.FreshserviceIncidentConfigurationMappingBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshserviceIncidentConfigurationMappingBase): boolean {
        Object.setPrototypeOf(obj, FreshserviceIncidentConfigurationMappingBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Freshservice incident attribute.
     */
    name: models.FreshserviceIncidentAttribute;

}
